import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { shortKey } from "apps-module/app/shared-library/utils/common.utils";

import { FacetFilterItemModel } from "../../../../models/facet-filter-item.model";

@Component({
    selector: "[pcg-ng-checkbox]",
    templateUrl: "./checkbox.component.html"
})
export class CheckboxComponent implements OnInit {
    public id: string = null;
    public control = new FormControl<boolean>(false);
    public model: FacetFilterItemModel = null;

    @Input("value")
    public set valueSetter(value: FacetFilterItemModel) {
        this.model = value || null;
        this.control.setValue(value?.selected || false);
    }

    @Output()
    public onChange = new EventEmitter();

    public ngOnInit(): void {
        this.id = shortKey();
    }

    public onToggle(): void {
        this.model.selected = this.control.value;
        this.onChange.emit(this.model);
    }
}
